module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section_bg-5ed098e3d8533f11e30633a07e0eadb2.png";